import TextareaAutosize from 'react-textarea-autosize'
import SearchButton from './searchButton'

import styles from '../styles/SearchForm.module.css'

export default function SearchForm(props) {

  const handleChange = (event) => {
    props.searchQueryInputSetter(event.target.value);
  }

  return (
    <form className={styles.form}>
      <TextareaAutosize maxRows={5} value={props.searchQuery} onChange={handleChange} placeholder="Search for ingredients separated by commas" className={styles.input_field}/>
      <SearchButton clicked={props.sendSearchQueryHandler} activated={props.buttonActivated}/>
    </form>
  )
}
